const forgetCookieConsentGiven = () => {
  window._paq.push(['forgetCookieConsentGiven'])
  // _paq.push(['forgetConsentGiven']);
}

export default forgetCookieConsentGiven
